export default "__VITE_ASSET__BLr2Q3D1__"